var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebCamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7301 9.50624L12.6452 10.574C13.5408 11.6189 13.9887 12.1414 13.9996 12.5837C14.0091 12.9682 13.8402 13.3354 13.5422 13.5783C13.1992 13.8579 12.511 13.8579 11.1348 13.8579H4.86533C3.489 13.8579 2.80083 13.8579 2.45783 13.5783C2.15973 13.3354 1.99084 12.9681 2.00038 12.5837C2.01136 12.1413 2.45923 11.6189 3.35496 10.5739L4.27013 9.50624M12.3515 7.0196C12.3515 9.42293 10.4033 11.3712 7.99992 11.3712C5.59658 11.3712 3.64829 9.42293 3.64829 7.0196C3.64829 4.61626 5.59658 2.66797 7.99992 2.66797C10.4033 2.66797 12.3515 4.61626 12.3515 7.0196ZM9.8649 7.0196C9.8649 8.0496 9.02992 8.88458 7.99992 8.88458C6.96991 8.88458 6.13493 8.0496 6.13493 7.0196C6.13493 5.98959 6.96991 5.15461 7.99992 5.15461C9.02992 5.15461 9.8649 5.98959 9.8649 7.0196Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCamIcon);
export default __webpack_public_path__ + "static/media/WebCamIcon.f50580ef40a756ea2e1adfe44a586fb8.svg";
export { ForwardRef as ReactComponent };